import type { BacktestJob } from "@/types/backtest"
import client from "./client"

export async function runAllBacktests(conditionNames: string[]): Promise<{ message: string; jobId: number }> {
  const { data } = await client.post<{ message: string; jobId: number }>("/api/backtest/run-all", {
    conditionNames,
  })
  return data
}

export async function getBacktestJob(jobId: number): Promise<BacktestJob> {
  const { data } = await client.get<BacktestJob>(`/api/backtest/jobs/${jobId}`)
  return data
}
